/* eslint-disable no-lone-blocks */
import React from 'react'
import { Field } from 'formik'
import { Typography } from '@material-ui/core'
import { Input } from 'sputnik-ui'
import styled from 'styled-components'

const StyledErrorTypography = styled(Typography)`
  color: ${(p) => p.theme.palette.danger.main} !important;
  margin-top: 0.5 rem;
  font-weight: 600;
  font-family: Open Sans;
  font-size: 12px;
`

const InputComponent = ({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => {
  return (
    <div>
      <Input {...field} {...props} />
      <StyledErrorTypography>{errors[field.name]}</StyledErrorTypography>
    </div>
  )
}

const FormField = (props) => <Field component={InputComponent} {...props} />

export default FormField
